import React from "react";

const DataAnalysis = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Data Analysis</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i class="uil uil-arrow"></i>
            <div>
              <h3 className="skills__name">PowerBI</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <i class="uil uil-arrow"></i>
            <div>
              <h3 className="skills__name">Microsoft Excel</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <i class="uil uil-arrow"></i>
            <div>
              <h3 className="skills__name">Google BigQuery</h3>
              <span className="skills__level">Basic</span>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <i class="uil uil-arrow"></i>
            <div>
              <h3 className="skills__name">Matplotlib /Seaborn</h3>
              <span className="skills__level">Basic</span>
            </div>
          </div>
          <div className="skills__data">
            <i class="uil uil-arrow"></i>
            <div>
              <h3 className="skills__name">SQL</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
          <div className="skills__data">
            <i class="uil uil-arrow"></i>
            <div>
              <h3 className="skills__name">R</h3>
              <span className="skills__level">Intermediate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataAnalysis;
